import {
  Component,
  OnInit,
} from "@angular/core";
import { Router} from "@angular/router";
import { ScheduleService } from "./schedule/schedule.service";
import { AuthService } from "./auth.service";

@Component({
  selector: "app-root",
  templateUrl: "./app.component.html",
  styleUrls: ["./app.component.css"],
})
export class AppComponent implements OnInit {
  title = "Raterhelper";
  toggleMenu = false;
  user;
  username;
  constructor(
    private scheduleService: ScheduleService,
    private router: Router,
    public auth: AuthService,
  ) { }

  public hvacContractor: boolean;
  setRoute = '';
  newTabMode = true;
  public contractor$ = this.auth.userProfile$;

  ngOnInit() {


    if(location.hash){
      let realUrl = location.href.split('#');

      this.router.navigate([realUrl[1]])
    }

    this.auth.userProfile$.subscribe(
      (profile) => {


        this.user = profile;
        this.username = this.user ? this.user.nickname.charAt(0).toUpperCase() + this.user.nickname.slice(1) : '';
      });


    this.auth.userProfileSubject$.subscribe(
      (profile) => {
        if (profile) {
          this.hvacContractor = (profile['https://rhv2.com.metadata'].role == 'HVACUser');
          if(this.hvacContractor)
          {
            let body = document.body;
            body.style.setProperty('overflow-y', 'scroll', 'important');
          }
          else {
              //this.scheduleService.init(profile);
              this.scheduleService.setProfile(profile);
          }
        }
      }, err => {
      }
    )
  }



  navigateTo(route): void {
    switch (route) {
      case "contacts":
          this.router.navigate(["/contacts"]);
          this.toggleAside();
          break;
      case "locations":
        this.router.navigate(["/locations"]);
        this.toggleAside();
        break;
      case "customers":
        this.router.navigate(["/customers"]);
        this.toggleAside();
        break;
      case "subdivision":
        this.router.navigate(["/subdivisions"]);
        this.toggleAside();
        break;
      case "cities":
        this.router.navigate(["/cities"]);
        this.toggleAside();
        break;
      case "jobtypes":
        this.router.navigate(["/jobtypes"]);
        this.toggleAside();
        break;
      case "employees":
        this.router.navigate(["/employees"]);
        this.toggleAside();
        break;
      case "login":
        this.router.navigate(["/login"]);
        this.toggleAside();
        break;
      case "plans":
        this.router.navigate(["/plans"]);
        this.toggleAside();
        break;
      case "home":
        this.router.navigate(["/home"]);
        this.toggleAside();
        break;
      case "builder":
        this.router.navigate(["/estar"]);
        this.toggleAside();
        break;
      case "schedule":
        this.router.navigate(["/schedule"]);
        this.toggleAside();
        break;
      case "visualmap":
        this.router.navigate(["/visualmap"]);
        this.toggleAside();
        break;
      case "billing":
        this.router.navigate(["/billing"]);
        this.toggleAside();
        break;
      case "customerjobs":
        this.router.navigate(["/customerjobs"]);
        this.toggleAside();
        break;
      case "heatmap":
        this.router.navigate(["/heatmap"]);
        this.toggleAside();
        break;
      case "version":
        this.router.navigate(["/version"]);
        this.toggleAside();
        break;
      case "design":
        this.router.navigate(["/design"]);
        this.toggleAside();
        break;
      case "design-overview":
        this.router.navigate(["/design-overview"]);
        this.toggleAside();
        break;
      case "homes":
        this.router.navigate(["/homes"]);
        this.toggleAside();
        break;
      case "equipment":
        this.router.navigate(["/equipment"]);
        this.toggleAside();
        break;
      case "hvacLocations":
        this.router.navigate(["/hvacLocations"]);
        this.toggleAside();
        break;
      case 'officesched':
        this.router.navigate(['/officesched']);
        this.toggleAside();
        break;
      case 'version':
        this.router.navigate(['/version'])
        this.toggleAside();
        break;
      case 'multifamily':
        this.router.navigate(['/multifamily'])
        this.toggleAside();
        break;
      case 'timetracking':
        this.router.navigate(['/timetracking'])
        this.toggleAside();
        break;
      case 'csvreports': 
        this.router.navigate(['/csvreports'])
        this.toggleAside();
        break;
      case 'timeadjustments':
        this.router.navigate(['/timeadjustments'])
        this.toggleAside();
        break;
    }
  }
  toggleAside() {
    this.toggleMenu = !this.toggleMenu;
  }
}
